import { supabase } from "@/integrations/supabase/client";
import { Session } from "@supabase/supabase-js";

// Module-level cache for subscription checks
let cachedSubscriptionResult: { subscribed: boolean; timestamp: number; userId: string } | null = null;
const SUBSCRIPTION_CACHE_TTL = 30000; // 30 seconds cache

export const checkUserSubscription = async (session: Session) => {
  const userId = session.user.id;
  const now = Date.now();
  
  // Check cache first
  if (cachedSubscriptionResult && 
      cachedSubscriptionResult.userId === userId &&
      now - cachedSubscriptionResult.timestamp < SUBSCRIPTION_CACHE_TTL) {
    console.log("[SubscriptionUtil] Using cached subscription result");
    return cachedSubscriptionResult.subscribed;
  }
  
  console.log("[SubscriptionUtil] Checking subscription for user:", userId);
  
  try {
    const { data: subscriptionData, error: subscriptionError } = 
      await supabase.functions.invoke('check-subscription', {
        headers: {
          Authorization: `Bearer ${session.access_token}`,
        }
      });
    
    if (subscriptionError) {
      console.error("[SubscriptionUtil] Subscription check error:", subscriptionError);
      throw subscriptionError;
    }
    
    if (!subscriptionData) {
      console.error("[SubscriptionUtil] No subscription data returned");
      throw new Error("No subscription data returned");
    }
    
    console.log("[SubscriptionUtil] Subscription check response:", subscriptionData);
    
    const subscribed = subscriptionData?.subscribed || false;
    
    // Cache the result
    cachedSubscriptionResult = {
      subscribed,
      timestamp: now,
      userId
    };
    
    return subscribed;
  } catch (error) {
    console.error("[SubscriptionUtil] Error checking subscription:", error);
    throw error;
  }
};

export const setupInitialSession = async () => {
  console.log("[SubscriptionUtil] Setting up initial session...");
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) {
      console.error("[SubscriptionUtil] Error getting session:", error);
      throw error;
    }
    return session;
  } catch (error) {
    console.error("[SubscriptionUtil] Error in setupInitialSession:", error);
    throw error;
  }
};